import { API_ENDPOINTS, ApiEndpoints } from '@contracts';
import { DEFAULT_API_ENDPOINTS } from '@core';

export const apiEndpointsProvider = {
  provide: API_ENDPOINTS,
  useValue: DEFAULT_API_ENDPOINTS,
};
